import React from 'react';
import { useTranslation } from 'react-i18next';

type Props = {
  days: number[];
};

export const useDays = ({ days }: Props) => {
  const { t } = useTranslation();

  const dayNames = [
    t("sun"),
    t("mon"),
    t("tue"),
    t("wed"),
    t("thu"),
    t("fri"),
    t("sat")
  ];

  return days.map(idx => dayNames[idx]);
};
